import axios from "axios";
import utils from "../utils";

const getAllUser = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/users`);
  
    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }
  
    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const deleteOneUser = async (deletionId) => {
  console.log("deleteOneUser function is called with user_id: ", deletionId);
  try {
    const user = await axios.get(`${utils.baseUrl}/users/${deletionId}`);
    
    if (user.data.role === 3) {
      const allPersonalTrainers = await axios.get(`${utils.baseUrl}/personal_trainers`);
      const personalTrainer = allPersonalTrainers.data.find(trainer => trainer.user_id === deletionId);
      if (personalTrainer) {
        const deleteTrainerResponse = await axios.delete(`${utils.baseUrl}/personal_trainers/${personalTrainer.id}`);
        console.log("deleteTrainerResponse: ", deleteTrainerResponse);
      }
    } else if (user.data.role === 4) {
      const allMembers = await axios.get(`${utils.baseUrl}/members`);
      const member = allMembers.data.find(member => member.user_id === deletionId);
      if (member) {
        const deleteMemberResponse = await axios.delete(`${utils.baseUrl}/members/${member.id}`);
        console.log("deleteMemberResponse: ", deleteMemberResponse);
      }
    }
    const response = await axios.delete(`${utils.baseUrl}/users/${deletionId}`);
    console.log("deleteOneUser response: ", response);

    return {
      message: response.data.message,
      status: response.status
    }
  } catch (error) {
    console.error("deleteOneUser error: ", error);
    return {
      message: error.response?.data?.message || error.message
    }
  }
}




const updateOneUser = async (user_id, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/users/${user_id}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const createOneUser = async (data) => {
  try {
    const response = await axios.post(`${utils.baseUrl}/users`, data);
    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const updateOnePersonalTrainer = async (user_id, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/pt_details/${user_id}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const getAllTrainerBookingList = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/personal_trainer_bookings`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const getUserIdByTrainerId = async (trainer_id) => {
  try {
    const response = await axios.get(`${utils.baseUrl}/personal_trainers/${trainer_id}`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const getAllTrainer = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/personal_trainers`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const getAllMember = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/members`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const getAllPtDetails = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/pt_details`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const updatePtDetails = async (id_pt_details, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/pt_details/${id_pt_details}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const deletePtDetails = async (id_pt_details) => {
  try {
    const response = await axios.delete(`${utils.baseUrl}/pt_details/${id_pt_details}`);

    return {
      message: response.data.message,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message
    }
  }
}

const addPtDetails = async (data) => {
  try {
    const response = await axios.post(`${utils.baseUrl}/pt_details`, data);
    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const updatePt = async (id_pt, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/personal_trainers/${id_pt}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const userService = {
  getAllUser,
  deleteOneUser,
  updateOneUser,
  createOneUser,
  updateOnePersonalTrainer,
  getAllTrainerBookingList,
  getUserIdByTrainerId,
  getAllTrainer,
  getAllMember,
  getAllPtDetails,
  updatePtDetails,
  deletePtDetails,
  addPtDetails,
  updatePt,
}

export default userService;